import { Stack } from '@mui/material';
import { type PropsWithChildren, Suspense } from 'react';

import { Loader } from '@vivaahealth/design-system';

export function LazyLoader(props: PropsWithChildren) {
  const { children } = props;
  return (
    <Suspense
      fallback={
        <Stack
          flex={1}
          alignContent="center"
          justifyContent="center"
          sx={{
            opacity: 0,
            '@keyframes FADE_IN': {
              '0%': {
                opacity: 0,
              },
              '50%': {
                opacity: 0,
              },
              '100%': {
                opacity: 1,
              },
            },
            animation: 'FADE_IN 1s forwards ease-in',
          }}
        >
          <Loader label="Loading page..." />
        </Stack>
      }
    >
      {children}
    </Suspense>
  );
}
